<template>
	<v-card flat class="comment-reply elevation-0">
		<div class="d-flex flex-fill comment-reply__outer-box">

			<router-link
				:to="{
					name: isCurrentUser(this.post.user.user_id) ? 'profile' : 'user-by-id',
					params: isCurrentUser(this.post.user.user_id) ? [] : {id: this.post.user.user_id}
				}"
				class="d-flex align-start text-decoration-none"
				:class="{ disabled: this.post.user.user_hidden }"
			>
				<Avatar class="mr-6 mb-3" size="51" :avatar="comment.authorAvatar" />
			</router-link>

			<div class="comment-reply__info-box">

					<v-card-title class="pl-0 comment-reply__title justify-space-between px-0 pt-0 mb-2">
						<div class="d-flex mr-1 flex-wrap">
							<router-link
								:to="{
									name: isCurrentUser(this.post.user.user_id) ? 'profile' : 'user-by-id',
									params: isCurrentUser(this.post.user.user_id) ? [] : {id: this.post.user.user_id}
								}"
								class="d-flex text-decoration-none comment-card__link"
								:class="{ disabled: this.post.user.user_hidden }"
							>
								{{ comment.authorName }}&nbsp;<span class="ml-1">replied to</span>&nbsp;
							</router-link>
	
							<router-link
								:to="{
									name: isCurrentUser(this.parentComment.user.user_id) ? 'profile' : 'user-by-id',
									params: isCurrentUser(this.parentComment.user.user_id) ? [] : {id: this.parentComment.user.user_id}
								}"
								class="d-flex flex-column text-decoration-none comment-card__link"
								:class="{ disabled: this.parentComment.user.user_hidden }"
							>
								{{ parentComment.authorName }}
							</router-link>
						</div>
						<div class="comment-reply__date">
							{{ comment.date }}
						</div>
					</v-card-title>

					<v-card-subtitle class="px-0 comment-reply__subtitle mb-2">
						{{ comment.user.second_profile_row }}
					</v-card-subtitle>

				<v-card-actions v-if="this.isAuthenticated" class="pl-0">

					<CommentEditForm
						v-if="isEdit"
						:parent="parentComment"
						:comment="comment"
						v-click-outside="hideEditInput"
						@success="
							() => {
								this.isEdit = false
							}
						"
					/>

				</v-card-actions>

				<v-card-text
					v-if="!this.isEdit"
					class="px-0 pb-0 comment-reply__content"
					v-html='contentFormateChangeMentions(comment.content)'
				></v-card-text>
				<v-card-actions v-if="this.isAuthenticated" class="d-flex justify-space-between flex-wrap pl-0" style="row-gap: 4px">
					<div class="d-flex align-center">
						<span 
							:class="isCurrentUserLike ? 'comment-reply__like-btn-active' : 'comment-reply__like-btn'" 
							@click="handleLikeComment(comment)"
						>
							<Icon
                                type='like'
                                color='var(--accent-color)'
                                :size='16'
								:pr="8"
                            />
							<span>
								{{ upvoteCount }}
							</span>
						</span>
						<span class="comment-reply__replies-count mr-5 ml-10">
							<Icon
                                type='comment'
                                color='var(--accent-color)'
                                :size='16'
								:pr="8"
                            />
							<span class="comment-reply__replies-count-num">
								{{ repliesCount }}
							</span>
						</span>
					</div>


					<div class="reply_buttons" >
						<v-btn
							class="comment-reply__button px-0"
							@click="handleDeleteComment(comment)"
							v-ripple="false"
							v-if="isOwnCurrentUserComment"
							color="transparent"
						>
							Delete
						</v-btn>
						<v-btn
							class="comment-reply__button px-0 ml-4"
							@click="replyHandler"
							v-ripple="false"
							color="transparent"
						>
							Reply
						</v-btn>
					</div>
				</v-card-actions>

				<ReplyCommentForm
					v-if="isReply"
					:comment="comment"
					:post="post"

					:parent="parentComment"

					v-click-outside="hideInput"
					:isReply="isReply"
					@success="successReply"


				/>
				<div v-if="level < 2">
					<Reply
						class="mb-5 mt-5"
						v-for="reply in replies"
						:reply-on-reply="true"
						:key="reply.id"
						:comment="reply"
						:post="{
							thread_id: reply.threadId,
							user: reply.user
						}"
						:level="level + 1"
						:parent-comment="comment"
					/>
				</div>
			</div>
		</div>
		<div v-if="level >= 2">
			<Reply
				class="mb-5 mt-5 comment-reply-low-level"
				v-for="reply in replies"
				:reply-on-reply="true"
				:key="reply.id"
				:comment="reply"
				:post="{
					thread_id: reply.threadId,
					user: reply.user
				}"
				:level="level + 1"
				:parent-comment="comment"
			/>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Avatar from '@/components/Avatar'
import CommentEditForm from '@/components/Forms/CommentEditForm'
import ReplyCommentForm from '@/components/Forms/ReplyCommentForm'
import { normalizeComment } from '@/utils/helpers'

import likedIcon from '@/assets/images/postIcon/icon-liked.svg'
import likeIcon from '@/assets/images/postIcon/icon-like.svg'

export default {
	name: 'Reply',
	props: {
		comment: {
			type: Object,
			default: () => {},
		},
		replyOnReply: {
			type: Boolean,
			default: false,
		},
		parentComment: {
			type: Object,
			default: () => {},
		},
		post: {
			type: Object,
			default: () => {}
		},
		level: {
			type: Number,
			default: 0
		}
	},
	components: {
		Avatar,
		CommentEditForm,
		ReplyCommentForm,
	},
	data() {
		return {
			isReply: false,
			isEdit: false,
			isLike: false,
			likedIcon,
			likeIcon
		}
	},
	methods: {
		...mapActions('post', ['deleteComment', 'likeComment']),
		hideInput() {
			this.isReply = false
		},
		hideEditInput() {
			this.isEdit = false
		},
		successReply() {
			this.isReply = false
		},
		replyHandler() {
			this.inputFocus = true
			this.isReply = !this.isReply
		},
		handleDeleteComment(comment) {
			this.deleteComment(comment)
		},
		handleLikeComment(comment) {
			this.likeComment(comment)
		},
		isCurrentUser(userId) {
			if (!this.profile) {
				return false
			}

			const {user_id: currentUserId} = this.profile

			return userId === currentUserId;
		},
		contentFormateChangeMentions(content) {
			const pattern = /@\[\d+\|[^]+?\]/g;
			const matches = content.match(pattern);

			let result = content

			if (matches) {
				for (let  i = 0; i < matches.length; i++) {
					const user_name = matches[i].match(/\|(.+?)\]/)[1];
					const user_id = matches[i].match(/@\[(\d+)\|/)[1];
					const replacement = `<a class="text-decoration-none" href="${process.env.VUE_APP_PUBLIC_PATH}users/${user_id}"><span>@${user_name}</span></a>`;

					result = result.replace(matches[i], replacement);
				}
			}

			return result
		}
	},
	computed: {
		...mapGetters('auth', ['isAuthenticated', 'profile']),

		replies() {
			return this.comment.replies.map((item) => normalizeComment(item)).reverse()
		},
		isCurrentUserLike() {
			return !!this.comment.upvote;
		},
		upvoteCount() {
			return this.comment.upvoteCount || 0;
		},
		repliesCount() {
			return this.comment.replies.length;
		},
		isOwnCurrentUserComment() {
			return this.comment.userId === this.profile.user_id
		},
		hostName() {
			return window.location.hostname || 'localhost';
		},
		protocol() {
			return window.location.protocol || 'http'
		},
		dateCreated() {
			const date = new Date(this.comment.date)
			const options = { year: 'numeric', month: 'long', day: 'numeric' }
			return date.toLocaleDateString('en-US', options)
		}

	},
}
</script>

<style lang="scss">
.reply_buttons {
	display: flex;
	align-items: center;

}
.v-card {
	&__actions {
		align-items: flex-start;
	}
}

.comment-card {
	&__link {
		color: var(--username-category-title) !important;
	}
}

.comment-reply {
	margin-top: -5px!important;
	border-left: -5px solid rgba(0, 0, 0, 0.2);
	background-color: #F3F3F6!important;
	padding-left: 5px;
	@media (max-width: 480px) {
		margin-left: 30px;
	}

	&__title {
		font-style: normal;
		font-weight: 700;
		font-size: 16px;
		line-height: 20px;
		color: #41a0d8;

		span {
			color: rgba(0, 0, 0, 0.4) !important;
		}
	}

	&__subtitle {
		color: var(--company-position-large);
	}

	&__content {
		font-size: 16px;
		line-height: 25px;
		color: #000000;
		& span {
			font-weight: bold;
			color: #42a0d8;
			cursor: pointer;
		}
	}

	&__button {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		margin-top: 2px;
		background: none !important;
		box-shadow: none !important;
		font: 14px/1.2 'Montserrat' !important;
		text-transform: none;
		letter-spacing: 0.35px;
		color: var(--button-secondary-background-color) !important;
		mix-blend-mode: normal;
		min-width: auto !important;
		line-height: 17.07px;
		font-weight: 700 !important;
		text-decoration: underline;

		&:hover {
			background: none;
			text-decoration: none;
		}

		&:before {
			content: none;
		}
	}

	&__like-btn, &__like-btn-active {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		height: 16px;
		line-height: 16px;
		cursor: pointer;
		display: flex;
		align-items: center;
	}
	&__like-btn {
		i, span {
			color: var(--accent-color) !important;
		}

		&-active {
			i, span {
				color: #a0a0a0 !important;
			}
		}
	}

	&__replies-count {
		display: flex;
		align-items: center;
		&-icon {
			color: var(--accent-color) !important;
			position: relative;
			top: 2px;
		}
		&-num {
			font-size: 13px;
			color: var(--accent-color);
		}
	}

	&__date {
		font-size: 13px;
		line-height: 19.37px;
		color: #697583;
		font-weight: 400;
	}

	@media screen and (max-width: 768px) {
		&__outer-box {
			flex-direction: column;
		}
		&__info-box {
			width: 100%;
		}
	}
}

.comment-reply-low-level {
	border: none;
	padding-left: 0;
}

</style>
